import React from 'react';
import Table from '../MCAnswerBreakdownReport/components/Table';
import { useGetAnswerBreakdownReportMutation } from '../../../../../../features/authentication/reportApiSlice';
import { useEffect, useState } from 'react';
import HesSpinner from '../../../../../../components/loadingOverlay/hesSpinner';
import CustomToast from '../../../../../../components/Toast';
import { downloadCSV } from '../../../../utils';
import { useParams } from 'react-router';
import HeaderToolbarContent from '../../../../../../components/TimeOnTaskReport/HeaderToolbar';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import usePrintPdfGenerator from '../../../../../../utils/PrintPdfGenerator';
import PageSize from '../../../../../../enums/pageSize';
import ActivityTypes from '../../../../../../enums/activityTypes';

const MCAnswerBreakdownReport = () => {
  const [answerBreakdownReport] = useGetAnswerBreakdownReportMutation();
  const { Id } = useParams();
  const [answerBreakdownResponse, setAnswerBreakdownResponse] = useState();
  const [openedQuestions, setOpenedQuestions] = React.useState([]);
  const [loader, setLoader] = React.useState(false);
  const [isExporting, setIsExporting] = useState(false);
  const { printPDF, isPdfGenerating } = usePrintPdfGenerator();
  const { activityType } = useParams();

  const getMCAnswerBreakdownReportAsync = async () => {
    setLoader(true);
    try {
      const options = {
        assignmentId: Id
      };
      const allMCAnswerBreakdownResponse = await answerBreakdownReport(options).unwrap();
      setLoader(false);

      const updatedAnswerBreakdownQuestions = JSON.parse(
        JSON.stringify(allMCAnswerBreakdownResponse.answerBreakdownQuestions)
      );
      updatedAnswerBreakdownQuestions.forEach((question) => {
        const missingResponseIndex = question.questionResponses.findIndex(
          (response) => response.response === 'Missing'
        );

        if (missingResponseIndex !== -1) {
          const missingResponse = question.questionResponses.splice(missingResponseIndex, 1);
          question.questionResponses.push(missingResponse[0]);
        }
      });

      let tempAnswerBreakdownResponse = { ...allMCAnswerBreakdownResponse };
      tempAnswerBreakdownResponse.answerBreakdownQuestions = updatedAnswerBreakdownQuestions;

      setAnswerBreakdownResponse(tempAnswerBreakdownResponse);
    } catch (error) {
      setLoader(false);
      console.log(error);
      CustomToast(error.data, 'error');
    }
  };

  useEffect(() => {
    getMCAnswerBreakdownReportAsync();
  }, []);

  const exportHandler = async () => {
    setIsExporting(true);
  
    const rows = [];
    rows.push([activityType == ActivityTypes.Assessment ? 'Assessment' : 'Assignment', answerBreakdownResponse.assignmentName]);
    rows.push(['Course', answerBreakdownResponse.courseName]);
    rows.push(['School Name', answerBreakdownResponse.schoolName]);
    rows.push(['Report Date', new Date().toLocaleString()]);
    rows.push([]);

    answerBreakdownResponse.answerBreakdownQuestions.forEach((question) => {
      rows.push([`Question ${question.questionNo} (${question.questionType}) (${question.questionType === 'MC' && question.isQuarantined === false
        ? `${question.assignedStudentCount} Students`
        : question.isQuarantined === true
          ? 'Quarantined Question'
          : `${question.crScoredStudentCount} of ${question.assignedStudentCount} scored`})`]);
          
      rows.push([]);
      rows.push(['Question Standards']);
      question.questionStandards.forEach((std) => {
        rows.push([std.standardName, std.standardDescription]);
      });
  
      rows.push([]);
      rows.push([question.questionType == 'MC' ? 'Response' : 'Points', 'Count', 'Percentage']);
  
      question.questionResponses.forEach((res) => {
        const percentage =
          question.assignedStudentCount > 0
            ? ((res.count / question.assignedStudentCount) * 100).toFixed(2) + '%'
            : '0%';
  
        rows.push([res.response, res.count, percentage]);
      });
  
      rows.push([]);
      rows.push([]);
    });
  
    const csvContent = rows.map(row => row.join(',')).join('\n');
  
    downloadCSV(csvContent, 'AnswerBreakdownReport');
    setIsExporting(false);
  };
  
  const handlePrint = async () => {
    if(isPdfGenerating) return;

    const contentWrapper = document.getElementById('session_pdf_Wrapper');
    const htmlString = contentWrapper.innerHTML;

    const tempContainer = document.createElement('div');
    tempContainer.innerHTML = htmlString;

    const buttonGroup = tempContainer.querySelector('#buttonGroup');
    buttonGroup.classList.add('d-none');

    const answerDetails = tempContainer.querySelectorAll('.tbl-details');
    answerDetails.forEach((answerDetail) => {
      answerDetail.classList.remove('d-none');
    });

    const standardDetails = tempContainer.querySelectorAll('.question_standard_info');
    standardDetails.forEach((standardDetail) => {
      standardDetail.classList.remove('d-none');
      standardDetail.classList.add('question_standard_info_dup');
      standardDetail.classList.add('h-auto');
      standardDetail.classList.add('mb-3');
    });

    const toggleIcons = tempContainer.querySelectorAll('.rounded-circle');
    toggleIcons.forEach((toggleIcon) => {
      toggleIcon.classList.add('d-none');
    });

    const answerResponses = tempContainer.querySelectorAll('.response-text');
    answerResponses.forEach((answerResponse) => {
      answerResponse.classList.add('d-none');
    });

    const crIcons = tempContainer.querySelectorAll('.cr-icon');
    crIcons.forEach((crIcon) => {
      crIcon.style.height = '15px';
      crIcon.style.width = '15px';
    });

    await printPDF('AnswerBreakdownReport', tempContainer.innerHTML, PageSize.A3);
  };

  if (loader) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '40px' }}>
        <HesSpinner />
        <span className="ms-3">Loading results...</span>
      </div>
    );
  }

  const generateInfo = () =>{
    return (
      <div>
        <OverlayTrigger
          key="tooltip-add"
          placement="right"
          overlay={
            <Tooltip id="add-tooltip" className="co-teacher-tooltip">
              <div className='d-flex gap-1 mb-2'><div className='colored-dot mt-1 bg-success'></div><div>85% or more of students got the question correct</div></div>
              <div className='d-flex gap-1 mb-2'><div className='colored-dot mt-1 bg-warning'></div><div>75% to 84% of students got the question correct</div></div>
              <div className='d-flex gap-1'><div className='colored-dot mt-1 bg-danger'></div><div>74% or less of students got the question correct</div></div>
            </Tooltip>
          }>
          <FontAwesomeIcon
            className="circle-question"
            icon={faQuestionCircle}
          />
        </OverlayTrigger>
      </div>
    );
  };

  const generateHeaderDetails = () =>{
    return (
      <div className="student_response_details">
        <div className="d-flex justify-content-between">
          <div className="student_response_details_left">
            <p>{activityType == ActivityTypes.Assessment ? 'Assessment' : 'Assignment'} : <strong>{answerBreakdownResponse?.assignmentName}</strong></p>
            <p>Course: <strong>{answerBreakdownResponse?.courseName}</strong></p>
          </div>
          <div className="student_response_details_right">
            <p> School: <strong>{answerBreakdownResponse?.schoolName}</strong></p>
          </div>
        </div>
      </div>
    );
  };
  return (
    <div className="white-card">
      <div id='session_pdf_Wrapper'>
        <HeaderToolbarContent
          reportTitle='Answer Breakdown Report'
          printHandler={handlePrint}
          isExporting={isExporting}
          isDownloading={isPdfGenerating}
          hideClassDropdown={true}
          backButtonOnClick={() => window.history.back()}
          hideFerpa={true}
          info={generateInfo()}
          headerDetails={generateHeaderDetails()}
          exportHandler={exportHandler}
        />
        {answerBreakdownResponse?.answerBreakdownQuestions.map((summary, index) => (
          <div key={summary.questionNo}>
            <Table
              title={`Question ${summary.questionNo}`}
              subtitle={
                summary.questionType === 'MC' && summary.isQuarantined === false
                  ? `${summary.assignedStudentCount} Students`
                  : summary.isQuarantined === true
                    ? 'Quarantined Question'
                    : `${summary.crScoredStudentCount} of ${summary.assignedStudentCount} scored`
              }
              questionText={summary.questionText}
              setOpenedQuestions={setOpenedQuestions}
              openedQuestions={openedQuestions}
              questionStandards={summary.questionStandards}
              questionResponses={summary.questionResponses}
              studentCount={summary.assignedStudentCount}
              tableShow={summary.studentCount > 0}
              index={index + 1}
              responseCount={summary?.questionResponses?.length}
              isCrQuestion ={summary.questionType === 'CR'}
              questionId = {summary.questionId}
              questionType={summary.questionType}
              courseId={summary.courseId}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default MCAnswerBreakdownReport;
